import styled, { css } from 'styled-components'

import { colors } from '../../../../../../shared/styles/colors'
import dimensions from '../../../../../../shared/styles/dimensions'

const { componentHeight } = dimensions

interface IInputProps {
  disabled?: boolean
}

export const StyledInput = styled.input<IInputProps>`
  width: 100%;
  height: ${componentHeight.large}px;

  border: 1px solid ${colors.grayLight};
  border-radius: 4px;

  padding: 12px 10px;

  font-weight: 400;
  font-size: 12px;

  margin: 10px 0px;

  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
      background-color: ${colors.white};
    `}
`

export const Label = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-size: 14px;
  font-weight: normal;
  color: ${colors.blue};
`
